import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import React, { useState } from "react"

/**
 * @deprecated - use TriCheckbox
 */
export const Checkbox = ({
    isChecked,
    onClick,
    size = "normal",
    isDisabled = false,
    hasUncheckedStyles,
}: {
    isChecked: boolean
    onClick: (e: React.MouseEvent) => void
    size?: "normal" | "small"
    isDisabled?: boolean
    hasUncheckedStyles?: boolean
}) => {
    const [isHovering, setIsHovering] = useState(false)
    const [isPressed, setIsPressed] = useState(false)

    return (
        <div
            className={classNames("rounded-md flex items-center justify-center aspect-square", {
                "w-[1.375rem] h-[1.375rem]": size === "normal",
                "w-5 h-5": size === "small",
                "bg-gray-700 border-t border-t-black-400": isChecked && !isHovering && !isDisabled,
                "border-gray-100": !isChecked && (!isHovering || isPressed) && !isDisabled,
                "border-gray-0 shadow-context-menu":
                    !isChecked && isHovering && !isPressed && !isDisabled,
                "border bg-gray-800 group-hover:border-gray-0": !isChecked && !isDisabled,
                "bg-gray-900": isChecked && isHovering && !isDisabled,
                "border-b border-b-white-200": isChecked && isHovering && !isPressed && !isDisabled,
                "border border-gray-300": isDisabled,
                "cursor-pointer": !isDisabled,
                "cursor-not-allowed": isDisabled,
                "!border-none !bg-gray-900": !isChecked && hasUncheckedStyles,
            })}
            onClick={onClick}
            onMouseEnter={!isDisabled ? () => setIsHovering(true) : undefined}
            onMouseLeave={
                !isDisabled
                    ? () => {
                          setIsHovering(false)
                          setIsPressed(false)
                      }
                    : undefined
            }
            onMouseDown={!isDisabled ? () => setIsPressed(true) : undefined}
            onMouseUp={!isDisabled ? () => setIsPressed(false) : undefined}
        >
            {isChecked && !isDisabled && (
                <Icons.SmallIcon
                    Icon={Icons.Checkmark}
                    className={classNames({
                        "-mb-0.5": isHovering && !isPressed,
                        "text-green-500": !isPressed,
                        "text-green-700 -mb-px": isPressed,
                    })}
                />
            )}
            {!isChecked && !isDisabled && hasUncheckedStyles && (
                <Icons.SmallIcon
                    Icon={Icons.XClose}
                    className={classNames({
                        "text-red-500": !isPressed,
                        "text-red-700 -mb-px": isPressed,
                    })}
                />
            )}
        </div>
    )
}

export type TriCheckboxState = "checked" | "unchecked" | "indeterminate"

export const TriCheckbox = ({
    state,
    onClick,
    size = "normal",
    isDisabled = false,
    className,
}: {
    state: TriCheckboxState
    onClick?: (e: React.MouseEvent) => void
    size?: "normal" | "small"
    isDisabled?: boolean
    className?: string
}) => {
    const [isHovering, setIsHovering] = useState(false)
    const [isPressed, setIsPressed] = useState(false)

    const isChecked = state === "checked"
    const isIndeterminate = state === "indeterminate"
    const isUnchecked = state === "unchecked"

    const renderIcon = () => {
        if (isChecked)
            return (
                <Icons.SmallIcon
                    Icon={Icons.Checkmark}
                    className={classNames(isPressed ? "text-green-700" : "text-green-500")}
                />
            )

        if (isIndeterminate) return <Icons.SmallIcon Icon={Icons.Minus} className="text-gray-200" />

        return null
    }

    return (
        <div
            className={classNames(
                "rounded-md flex items-center justify-center aspect-square",
                {
                    "w-[1.375rem] h-[1.375rem]": size === "normal",
                    "w-5 h-5": size === "small",

                    "border-t border-t-black-400 bg-white-200":
                        (isChecked || isIndeterminate) && !isHovering && !isPressed,
                    "border-t border-t-white-200 bg-white-200":
                        (isChecked || isIndeterminate) && isHovering && !isPressed,
                    "bg-white-200": (isChecked || isIndeterminate) && isPressed,

                    "border border-gray-100": isUnchecked && (!isHovering || isPressed),
                    "border border-gray-0 shadow-context-menu":
                        isUnchecked && isHovering && !isPressed,

                    "border-gray-300 cursor-not-allowed": isDisabled,
                    "cursor-pointer": !isDisabled,
                },
                className
            )}
            onClick={!isDisabled ? onClick : undefined}
            onMouseEnter={!isDisabled ? () => setIsHovering(true) : undefined}
            onMouseLeave={
                !isDisabled
                    ? () => {
                          setIsHovering(false)
                          setIsPressed(false)
                      }
                    : undefined
            }
            onMouseDown={!isDisabled ? () => setIsPressed(true) : undefined}
            onMouseUp={!isDisabled ? () => setIsPressed(false) : undefined}
        >
            {renderIcon()}
        </div>
    )
}
